import React, { useState, useEffect, useRef } from 'react'
import AdminDashboardComponents from '../components/HigherOrderComponents/AdminDashboardComponents'
import AdminCustomerComponetNew from './AdminCustomerComponentNew';
import AdminSupplierComponentNew from './AdminSupplierComponentNew';
import { DropDownIcon, LucidLoader } from '../components/Icons';
import { getAllUsers } from '../utils/actions/allactions';
import { toast } from "react-toastify";
import { useLocation, useNavigate } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { getAllSuppliers } from '../utils/actions/supplierActions';
import { getAllCompanyWithouFilter } from '../utils/actions/adminActions';
import useDocumentTitle from '../utils/useDocumentTitle';
import { Checkbox, Input, Tooltip } from 'antd';
import { GenericSearchComponent } from '../components/GenericFiltersComponents';
import GenericLoaderComponent from './Loading/GenericLoaderComponent';


const AdminDashboardNew = () => {
    useDocumentTitle('Dashboard');
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const monthsFromURL = searchParams.get("months")?.split(",").map(Number) || [];
    const yearsFromURL = searchParams.get("years")?.split(",").map(Number) || [];
    const navigate = useNavigate();
    const token = localStorage.getItem("Token");
    const [selectedMode, setSelectedMode] = useState(0);
    const [userData, setUserData] = useState('');
    const [loading, setLoading] = useState(true);
    const [isMonthSelectorDropDownOn, setIsMonthSelectorDropDownOn] = useState(false);
    const [isYearSelectorDropDownOn, setIsYearSelectorDropDownOn] = useState(false);
    const [isCustomerDropDownOn, setIsAllCustomerDropDownOn] = useState(false);
    const [isCompanyDropdownOn, setIsCompanyDropdownOn] = useState(false);
    const [allCompany, setAllCompany] = useState([]);
    const [searchCompanyTerm, setSearchCompanyTerm] = useState('');
    const currentYear = new Date().getFullYear();
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const isUsingURLMonths = monthsFromURL.length > 0;

        return [
            { _id: -1, value: 'All Months', checked: !isUsingURLMonths }, // Select "All Months" if no specific months in URL
            { _id: 0, value: 'January', checked: isUsingURLMonths ? monthsFromURL.includes(0) : true },
            { _id: 1, value: 'February', checked: isUsingURLMonths ? monthsFromURL.includes(1) : true },
            { _id: 2, value: 'March', checked: isUsingURLMonths ? monthsFromURL.includes(2) : true },
            { _id: 3, value: 'April', checked: isUsingURLMonths ? monthsFromURL.includes(3) : true },
            { _id: 4, value: 'May', checked: isUsingURLMonths ? monthsFromURL.includes(4) : true },
            { _id: 5, value: 'June', checked: isUsingURLMonths ? monthsFromURL.includes(5) : true },
            { _id: 6, value: 'July', checked: isUsingURLMonths ? monthsFromURL.includes(6) : true },
            { _id: 7, value: 'August', checked: isUsingURLMonths ? monthsFromURL.includes(7) : true },
            { _id: 8, value: 'September', checked: isUsingURLMonths ? monthsFromURL.includes(8) : true },
            { _id: 9, value: 'October', checked: isUsingURLMonths ? monthsFromURL.includes(9) : true },
            { _id: 10, value: 'November', checked: isUsingURLMonths ? monthsFromURL.includes(10) : true },
            { _id: 11, value: 'December', checked: isUsingURLMonths ? monthsFromURL.includes(11) : true },
        ];
    });

    const [selectedYear, setSelectedYear] = useState(() => {
        const isUsingURLYears = yearsFromURL.length > 0;
        const years = [];
        let _id = 0;

        for (let year = 2020; year <= currentYear; year++) {
            years.push({
                _id,
                value: year,
                checked: isUsingURLYears ? yearsFromURL.includes(year) : year === currentYear
            });
            _id++;
        }

        return years;
    });
    const [searchTerm, setSearchTerm] = useState("");
    const [allCustomer, setAllCustomer] = useState([]);
    const updateQueryParams = (key, value) => {
        const searchParams = new URLSearchParams(location.search);
        const hasValue =
            (Array.isArray(value) && value.length > 0) ||
            (!Array.isArray(value) && value !== null && value !== undefined && value !== "");

        if (hasValue) {
            const paramValue = Array.isArray(value) ? value.join(",") : value;
            searchParams.set(key, paramValue);
        } else {
            searchParams.delete(key);
        }
        navigate(`?${searchParams.toString()}`, { replace: true });
    };

    const handleMonthChange = (id) => {
        console.log("Month id ::", id);
        let updatedMonths;
        if (id == -1) {
            const val = selectedMonth[0].checked;
            updatedMonths = selectedMonth.map((month) => ({ ...month, checked: !val }));
        } else {
            updatedMonths = selectedMonth.map(month => month._id == id ? { ...month, checked: !month.checked } : month);
        }

        setSelectedMonth(updatedMonths);
        updateQueryParams("months", updatedMonths.filter(m => m.checked).map(m => m._id));
    };

    const handleYearChange = (id) => {
        const updatedYears = selectedYear.map(year => year._id == id ? { ...year, checked: !year.checked } : year);

        setSelectedYear(updatedYears);
        updateQueryParams("years", updatedYears.filter(y => y.checked).map(y => y.value));
    };

    const handleCustomerChange = (id) => {
        const updatedCustomers = allCustomer.map(cus => cus.id == id ? { ...cus, checked: !cus.checked } : cus);

        setAllCustomer(updatedCustomers);
        updateQueryParams("customers", updatedCustomers.filter(c => c.checked).map(c => c.id));
    };

    const handleCompanyChange = (id) => {
        const updatedCustomers = allCustomer.map((item) => item.companySiteId != id ? { ...item, checked: false } : item);
        const updatedCompanies = allCompany.map((item) => item.id == id ? { ...item, checked: !item.checked } : item);

        setAllCustomer(updatedCustomers);
        setAllCompany(updatedCompanies);

        updateQueryParams("companies", updatedCompanies.filter(c => c.checked).map(c => c.id));
    };
    let decode;


    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.slice(0, maxLength) + '...';
        }
        return text;
    };

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);
            try {
                if (selectedMode == 0) {
                    const customerCompanyResponse = await getAllCompanyWithouFilter();
                    const getAllCustomerUsersResponse = await getAllUsers(token);
                    setAllCompany(() => {
                        return customerCompanyResponse.map((item) => {
                            return { ...item, value: item.companyName, id: item._id, checked: false };
                        })
                    })
                    setAllCustomer(() => {
                        return getAllCustomerUsersResponse.map((item) => {
                            return { ...item, value: `${item.firstName} ${(item.lastName || "")}`, checked: false, id: item._id }
                        });
                    })
                    const searchParams = new URLSearchParams(location.search);
                    const companiesFromURL = searchParams.get("companies")?.split(",").map(String) || [];
                    const customersFromURL = searchParams.get("customers")?.split(",").map(String) || [];

                    if (companiesFromURL.length) {
                        setAllCompany(customerCompanyResponse.map((item) => ({ ...item, value: item.companyName, id: item._id, checked: companiesFromURL.includes(item?._id) })));

                    }
                    if (customersFromURL.length) {
                        setAllCustomer(getAllCustomerUsersResponse.map((item) => ({ ...item, value: `${item.firstName} ${(item.lastName || "")}`, checked: customersFromURL.includes(item?._id), id: item._id })));
                    }
                    // Apply URL filters while setting state

                }
                else if (selectedMode == 1) {
                    const searchParams = new URLSearchParams(location.search);
                    const companiesFromURL = searchParams.get("companies")?.split(",").map(String) || [];

                    const supplierCompanyResponse = await getAllSuppliers(token);
                    if (supplierCompanyResponse.status) {
                        const data = supplierCompanyResponse.data;
                        setAllCompany(() => {
                            return data?.map((item) => {
                                return { ...item, value: item.companyName, id: item._id, checked: companiesFromURL.includes(item._id) };
                            })
                        })
                    }

                }
            } catch (error) {
                toast.error("Data fetch failed. Please try again later");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [selectedMode]);


    const filteredCustomers = allCustomer.filter(customer => {
        const selectedCompanyIds = allCompany.filter(item => item.checked).map((item) => item.id);
        if (selectedCompanyIds.length == 0) {
            return customer.value.toLowerCase().includes(searchTerm.toLowerCase())
        }
        return customer.value.toLowerCase().includes(searchTerm.toLowerCase()) && selectedCompanyIds.includes(customer.companySiteId)
    }
    );
    const filteredCompany = allCompany.filter(company => {
        return company.value.toLowerCase().includes(searchCompanyTerm.toLowerCase())
    }
    );
    console.log("allCustomer ::", allCustomer);
    console.log("Filtered customer ::", filteredCustomers);
    useEffect(() => {
        if (!token) {
            navigate("/");
            return;
        }

        decode = jwt_decode(token);
        setUserData(decode);
        if (!decode) {
            navigate("/");
            toast.error("Invalid token");
        }
        if (decode && decode.userType != 'admin') {
            navigate('/');
        }
    }, []);
    const monthDropDownRef = useRef();
    const yearDropDownRef = useRef();
    const companyDropDownRef = useRef();
    const customerDropDownRef = useRef();

    const handleDropDownOutSideClick = (e) => {
        if (
            selectedMode === 0 &&
            monthDropDownRef.current &&
            yearDropDownRef.current &&
            companyDropDownRef.current &&
            customerDropDownRef.current &&
            !monthDropDownRef.current.contains(e.target) &&
            !yearDropDownRef.current.contains(e.target) &&
            !companyDropDownRef.current.contains(e.target) &&
            !customerDropDownRef.current.contains(e.target)
        ) {
            setIsMonthSelectorDropDownOn(false);
            setIsYearSelectorDropDownOn(false);
            setIsAllCustomerDropDownOn(false);
            setIsCompanyDropdownOn(false);
        }

        if (
            selectedMode === 1 &&
            monthDropDownRef.current &&
            yearDropDownRef.current &&
            companyDropDownRef.current &&
            !monthDropDownRef.current.contains(e.target) &&
            !yearDropDownRef.current.contains(e.target) &&
            !companyDropDownRef.current.contains(e.target)
        ) {
            setIsMonthSelectorDropDownOn(false);
            setIsYearSelectorDropDownOn(false);
            setIsCompanyDropdownOn(false);
            // Notice: no setIsAllCustomerDropDownOn here
        }
    };


    useEffect(() => {
        document.addEventListener("mousedown", handleDropDownOutSideClick);
        return () => document.removeEventListener("mousedown", handleDropDownOutSideClick);

    }, [selectedMode]);



    const searchConfig = [
        {
            title: `(${(selectedMonth.reduce((pre, item) => pre + Number(item.checked), 0))}) months selected`,
            onCheckboxClick: (id) => handleMonthChange(id),
            type: "dropdown",
            data: selectedMonth,
            maxDropdownHeight: 'max-h-auto',
            label: 'Select Month',
            onChangeValueInput: '_id',
        },
        {
            title: `(${(selectedYear.reduce((pre, item) => pre + Number(item.checked), 0))} ) years selected`,
            onCheckboxClick: (id) => handleYearChange(id),
            type: "dropdown",
            data: selectedYear,
            maxDropdownHeight: 'max-h-auto',
            label: 'Select Year',
            onChangeValueInput: '_id',

        },
        {
            type: "search & dropdown",
            title: `(${(allCompany.reduce((pre, item) => pre + Number(item.checked), 0) || "All")}) company selected`,
            placeholder: 'Search companies',
            data: filteredCompany,
            onSearch: (value) => setSearchCompanyTerm(value),
            onCheckboxClick: (id) => handleCompanyChange(id),
            displayKey: 'value',
            label: 'Select Company'

        },
    ]
    if (selectedMode == 0) {
        searchConfig.push({
            type: "search & dropdown",
            title: `(${allCustomer.reduce((pre, item) => pre + Number(item.checked), 0) || "All"}) customer selected `,
            placeholder: 'Search customers',
            data: filteredCustomers,
            onSearch: (value) => setSearchTerm(value),
            onCheckboxClick: (id) => handleCustomerChange(id),
            displayKey: 'value',
            label: 'Select Customer'

        });
    }
    return (
        <div className='w-full border select-none  border-red-500 min-h-screen px-10'>
            <h1 className='text-center mt-5 font-bold  text-2xl my-2'>Welcome {userData?.firstName}</h1>
            <GenericLoaderComponent
                isLoading={loading}
            />
            <div className='w-full flex items-center justify-center relative'>
                <div className={`absolute transition-all ${selectedMode == 0 ? "me-3 -rotate-90" : "ms-3 rotate-90"}`}>
                    <Arrow direction={selectedMode === 0 ? 'customer' : 'supplier'} />
                </div>
                <div
                    onClick={() => setSelectedMode(0)}
                    className={`h-10 w-1/5 flex border text-white items-center justify-center cursor-pointer transition-all duration-300 ${selectedMode === 0 ? "bg-primaryColor shadow-lg" : "bg-sky-600 border-sky-500"}`}
                >
                    Customer
                </div>
                <div
                    onClick={() => setSelectedMode(1)}
                    className={`h-10 w-1/5 flex border text-white items-center justify-center cursor-pointer transition-all duration-300 ${selectedMode === 1 ? 'bg-complementaryPrimaryColor shadow-lg' : "!border border-complementaryPrimaryColor bg-complementaryHoverColor"}`}
                >
                    Supplier
                </div>
            </div>
            <div>
                <GenericSearchComponent
                    config={searchConfig}
                    parentClassName={'filters flex items-center justify-between flex-wrap w-fu my-2'}
                />
            </div>
            {/* <div className='flex justify-start gap-x-2 '>
            <button className='h-10 bg-primaryColor px-5 text-white  py-2 flex items-center justify-center rounded'>Search </button>
            <button className='h-10 bg-red-500 px-5  text-white py-2 flex items-center justify-center rounded'>Reset </button>
        </div> */}
            {selectedMode == 0 && <AdminCustomerComponetNew
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                setCompany={setAllCompany}
                allCompany={allCompany}
                allCustomers={allCustomer}
                setAllCustomer={setAllCustomer}


            // setUser={}
            />}
            {selectedMode == 1 && <AdminSupplierComponentNew
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                setCompany={setAllCompany}
                allCompany={allCompany}

            />}
        </div>
    )
}

export default AdminDashboardComponents(AdminDashboardNew)


const Arrow = ({ direction }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke-linecap="round" stroke-linejoin="round" ><path d="M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" /></svg>

    );
};
